import { render, staticRenderFns } from "./EntregaAdd.vue?vue&type=template&id=245bdd6d&"
import script from "./EntregaAdd.vue?vue&type=script&lang=js&"
export * from "./EntregaAdd.vue?vue&type=script&lang=js&"
import style0 from "./EntregaAdd.vue?vue&type=style&index=0&id=245bdd6d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports